var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgApproval = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,2H7.5a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2h17a2,2,0,0,0,2-2V4A2,2,0,0,0,24.5,2ZM22.68,12.68l-8.62,8.1a1,1,0,0,1-1.37,0L9.32,17.61a1,1,0,0,1,1.36-1.46l2.7,2.53,7.94-7.46a1,1,0,0,1,1.36,1.46Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgApproval, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Approval.c1c7ecd0.svg";
export { ForwardRef as ReactComponent };